import BaseViewExtensionViewFactory from '@/Factories/ViewFactories/BaseViewExtensionViewFactory';
import ComponentManager from '@/Management/ComponentManager';
import CustomListViewViewModelT from '@/ViewModels/Views/CustomListViewViewModel';
import ListViewViewType from '@/Views/ListViewView';
import * as CoreFrameDTOs from "coreframetypings/dto";
import ResourceManager from '@/Management/ResourceManager';
import {
    ICustomListViewFactoryConstructorParameter,
    ICustomListViewViewModelParameters
} from "#/DefaultViewExtensionInterfaces";

export default class CustomListViewFactory extends BaseViewExtensionViewFactory {
    /**
     * @override
     * @inheritdoc 
     */
    public viewModel: CustomListViewViewModelT;

    protected dataSourceTypeName: string;
    protected dataSourceOperationName: string;
    protected listViewName: string;
    protected pageTitleErgName: string;
    protected selectedPDO: string | number;
    protected filter: string;
    protected customName: string;
    protected preFilter: string;
    protected titleExtension: string;

    constructor(params: ICustomListViewFactoryConstructorParameter) {
        super({
            viewModelName: 'CustomListViewViewModel',
            viewName: 'ListViewView',
            ...params,
        });
        
        this.dataSourceTypeName = params.dataSourceTypeName;
        this.dataSourceOperationName = params.dataSourceOperationName;
        this.listViewName = params.listViewName;
        this.pageTitleErgName = params.Title;
        this.selectedPDO = this.paramOrDefault(params.selectedPDO, '-1');
        this.filter = this.paramOrDefault(params.filter, '');
        this.customName = this.paramOrDefault(params.customName, '');
        this.preFilter = this.paramOrDefault(params.preFilter, '');
        this.titleExtension = this.paramOrDefault(params.titleExtension, '');
    }

    public getRegion(): string {
        return 'Content';
    }

    /**
     * @override
     */
    public getView() {
        this.resolveDependencies(['Wireframe']);

        if (!this.viewModel) {
            const parameters = this.createViewModelParameters();
            this.viewModel = this.createViewModel(parameters);
        }

        if (!this.view) {
            this.view = this.createView(this.viewModel);
        }

        this.setPageTitle(ResourceManager.getInstance().get(this.pageTitleErgName));
        this.viewModel.raiseHeaderChange();

        let tuple = this.view.getTuple();
        return tuple.view;
    }

    protected createViewModel(parameters: ICustomListViewViewModelParameters): CustomListViewViewModelT {
        const ViewModel = this.ViewModel as typeof CustomListViewViewModelT;
        return new ViewModel(parameters);
    }

    protected createViewModelParameters(): ICustomListViewViewModelParameters {
        return {
            dataSourceTypeName: this.dataSourceTypeName,
            filter: this.filter,
            dataSourceOperationName: this.dataSourceOperationName,
            viewName: this.listViewName,
            pageTitleErgName: this.pageTitleErgName,
            onBeforeColumnsComputedHandler: this.onBeforeColumnsComputed.bind(this),
            onBeforeListViewLoadedHandler: this.onBeforeListViewLoaded.bind(this),
            showPrincipalFilter: false,
            selectedPDO: this.selectedPDO,
            customName: this.customName,
            preFilter: this.preFilter,
            titleExtension: this.titleExtension,
            locator: this.locator
        };
    }

    protected createView(viewModel: CustomListViewViewModelT): ListViewViewType {
        const ListViewView = this.View as unknown as typeof ListViewViewType;
        return new ListViewView(viewModel, this.createRootElement('ListView'));
    }

    protected onBeforeColumnsComputed(columns: Array<any>): void {
        // Hook method
    }

    protected onBeforeListViewLoaded(listViewDTO: CoreFrameDTOs.IListViewDTO): void {
        // Hook method
    }

    /**
     * @override
     * @inheritdoc 
     */
    public refresh(): boolean {
        this.viewModel.dataGrid.refresh();
        return true;
    }

}

ComponentManager.setFactory('CustomListView', CustomListViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');